import Autosize from 'autosize';

const autosizeEls = document.querySelectorAll('.js-autosize');

Autosize(autosizeEls);
Autosize.update(autosizeEls);
